<template>
  <div>
    <ArticleListCommentsDialog ref="articleCommentsDialog"></ArticleListCommentsDialog>
    <ArticleLIstSharesDialog ref="articleSharesDialog"></ArticleLIstSharesDialog>
    <v-row>
      <!-- <pre>{{filteredArticles}}</pre> -->
      <v-col md="12">
        <v-row>
          <v-col md="6" v-for="item in filteredArticles" :key="item.id">
            <v-card class="mx-auto" max-width="600" outlined>
              <v-list-item three-line>
                <v-list-item-avatar tile size="150" color="grey"></v-list-item-avatar>
                <v-list-item-content>
                  <p class="headline" style="display:flex;">{{ item.Title }}</p>
                  <v-list-item-subtitle class="subtitle-2">
                    {{
                    item.Created | moment("LL")
                    }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="subtitle-2">Kategori: {{ item.Category }}</v-list-item-subtitle>
                  <v-divider></v-divider>
                  <v-row>
                    <v-col md="6">
                      <span>
                        <v-icon medium>fas fa-share-alt</v-icon>
                      </span>
                      <span
                        class="pl-3 subtitle-1 error--text"
                        style="cursor: pointer;"
                        @click="$refs.articleSharesDialog.openDialog(item)"
                      >324</span>
                      <span class="pl-3 subtitle-1">SHARES</span>
                    </v-col>
                    <v-col md="6">
                      <span>
                        <v-icon medium>far fa-comment-alt</v-icon>
                      </span>
                      <span
                        class="pl-3 subtitle-1 error--text"
                        style="cursor: pointer;"
                        @click="$refs.articleCommentsDialog.openDialog(item)"
                      >23</span>
                      <span class="pl-3 subtitle-1">COMMENTS</span>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import ArticleListCommentsDialog from "@/pages/private/components/dialog/articleListCommentsDialog.vue";
import ArticleLIstSharesDialog from "@/pages/private/components/dialog/articleLIstSharesDialog.vue";
export default {
  components: {
    ArticleListCommentsDialog,
    ArticleLIstSharesDialog,
  },
  data() {
    return {
      articleCommentsDialog: false,
      articleSharesDialog: false,
      Articles: [],
      ArticleTypes: [],
      SelectedArticleType: null,
      Content: [],
    };
  },
  computed: {
    filteredArticles() {
      let _articleType = this.SelectedArticleType || this.ArticleTypes[0];
      if (_articleType != this.SelectedArticleType)
        this.SelectedArticleType = _articleType;
      // Here is the variable to get title out of content array, by mapping it
      let _Articles = this.Articles.map((article) => {
        // archive.title shall now be displayed in the original language written
        article.Title = article.Content.find(
          (el) => el.Lang == article.OrgLanguage
        );
        // Here created get moment added into itself
        article.Created = this.$moment(article.Created).format("lll");
        // If not finding any title this way, then go to the first element that match the key title
        if (!article.Title) article.Title = article.Content[0].Title;
        // Else, make title key into the primary array
        else {
          article.Title = article.Title.Title;
        }
        return article;
      });
      if (!_articleType) {
        return this.Articles;
      }
      return this.Articles.filter(
        (article) => article.ArticleType == _articleType
      );
    },
  },

  methods: {
    // Edit the article, by going to the article id
    editArticle(articleId) {
      this.HISTORY_SET({ name: "listarticles" });
      this.$router.push({
        name: "editarticle",
        params: { articleid: articleId },
      });
    },
    ...mapMutations(["HISTORY_SET", "HISTORY_REMOVE"]),
    ...mapActions(["GET_ARTICLES"]),
  },
  mounted() {
    this.GET_ARTICLES().then((resp) => {
      this.Articles = resp.data.Articles;
      this.ArticleTypes = resp.data.ArticleTypes;
      // console.log(resp);
      // console.log(this.Articles);
    });
  },
};
</script>
